exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .staticPages{\r\n    height: calc(100vh - 472px);\r\n    overflow-y: auto;\r\n}\r\n\r\n@media (max-width:1023px) { \r\n    .staticPages{\r\n        height: inherit;\r\n    }\r\n} */\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/about/about.component.css
// module id = ../../../../../src/app/about/about.component.css
// module chunks = main